export const TypesEdicaoVolumes = {
    SET_PROPERTY: "edicaoVolumes/SET_PROPERTY",
    SET_PROPERTY_EDICAO_INFOS: "edicaoVolumes/SET_PROPERTY_EDICAO_INFOS"
}

export const INITIAL = {
    VolumeId: undefined,
    Etiqueta: '',
    LoteInicialId: undefined,
    Embalagens: [],
    Nodes: [],
    Expanded: [],
    MudaVolumeLote: false,
    EdicaoInfos: {
        LoteID: undefined,
        EditaLote: false,
        HintLote: '',
        LabelLote_RC: '',
        BtnGravar: false,
        BtnCancelar: false,
        EmbalagemID: undefined,
        EmbalagemDescricao: '',
        Contramarca: '',
        Comprimento: '',
        Largura: '',
        Altura: '',
        Peso: '',
        TipoTemperaturaVol: undefined,
        TemperaturaMin: '',
        TemperaturaMax: '',
        QuantidadeVolumes: 0
    }
}

export default function edicaoVolumesReducer(state = INITIAL, action) {
    switch (action.type) {
        case TypesEdicaoVolumes.SET_PROPERTY:
            let stateNew = {};

            Object.assign(stateNew, state);

            stateNew[action.payload.campo] = action.payload.valor;

            return stateNew;
        case TypesEdicaoVolumes.SET_PROPERTY_EDICAO_INFOS:
            let edicaoInfosNew = {};

            Object.assign(edicaoInfosNew, state.EdicaoInfos);

            edicaoInfosNew[action.payload.campo] = action.payload.valor;

            return {
                ...state,
                EdicaoInfos: edicaoInfosNew
            }
        default:
            return state;
    }
}

export const EdicaoVolumesActions = {
    setProperty,
    setPropertyEdicaoInfos
}

function setProperty(valor, campo) {
    return {
        type: TypesEdicaoVolumes.SET_PROPERTY,
        payload: { valor: valor, campo: campo }
    }
}

function setPropertyEdicaoInfos(valor, campo) {
    return {
        type: TypesEdicaoVolumes.SET_PROPERTY_EDICAO_INFOS,
        payload: { valor: valor, campo: campo }
    }   
}